import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import API_URL from "../../config/api";

export const fetchLoteDataDashboard = createAsyncThunk(
  'dashboard/fetchDashboardData',
  async ({ nomeTabela, lote }, thunkAPI) => {
    try {
      const token = JSON.parse(atob(localStorage.getItem('token') || '""'));
      const response = await axios.get(`${API_URL}/api/Dashboard/`, {
        params: {
          nomeTabela: nomeTabela,
          lote: lote
        },
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
      return response.data;
    }
    catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || 'Erro ao buscar dashboard');
    }
  }
);

const dashboardSlice = createSlice({
  name: 'dashboard',
  initialState: {
    data: null,
    status: 'idle',
    error: null
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchLoteDataDashboard.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchLoteDataDashboard.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.data = action.payload;
      })
      .addCase(fetchLoteDataDashboard.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload;
      });
  }
});

export default dashboardSlice.reducer;
